// 风险提醒
export function pieOption () {
  return {
    color: [],
    grid: {
      top: 0,
      bottom: '0px'
    },
    title: {
      top: 10,
      left: 'center',
      textStyle: {
        color: '#FFF',
        fontSize: '1.15vw'
      }
    },
    series: [
      {
        name: '访问来源',
        type: 'pie',
        radius: ['65%', '58%'],
        center: ['50%', '65%'],
        avoidLabelOverlap: false,
        hoverAnimation: false, // 关闭放大动画
        selectedOffset: 0, // 选中块的偏移量
        label: {
          show: false,
          position: 'center',
          formatter (params) {
            return params.value + '条'
          }
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '20',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          {
            value: 12,
            name: '直接访问',
            selected: true, // 默认选中第一块
            label: {
              show: true, // 默认显示第一块
              fontSize: '14'
            }
          },
          { value: 0, name: 'default' }
        ]
      }
    ]
  }
}

// 风险实时统计
export function pieOption1 (theme, myChart, data, name = '实时统计') {
  const titleName = name.slice(0, 2) + '\n' + name.slice(2)
  return {
    grid: {
      top: 30,
      bottom: 20
    },
    graphic: {
      elements: [
        {
          type: 'image',
          // z: 3,
          style: {
            text: titleName,
            fontSize: '0.8rem',
            color: theme === 'dark' ? '#FFF' : '#333333',
            image: theme === 'dark' ? require('@/assets/images/统计椭圆形.png') : require('@/assets/images/统计椭圆形-白.png'),
            width: myChart.getHeight() < myChart.getWidth() ? myChart.getHeight() - 20 : myChart.getWidth() - 20,
            height: myChart.getHeight() < myChart.getWidth() ? myChart.getHeight() - 20 : myChart.getWidth() - 20
          },
          left: 'center',
          top: 'center'
        }
      ]
    },
    tooltip: {
      trigger: 'item',
      textStyle: {
        fontSize: '12'
      },
      formatter: '{b0}'
    },
    series: [
      {
        name: name,
        type: 'pie',
        radius: ['40%', '70%'],
        startAngle: 180,
        minAngle: 15,
        avoidLabelOverlap: false,
        itemStyle: {
          borderColor: '#Fff',
          borderWidth: 1,
          color: function (params) {
            const colorList = [['#59A7FF', '#1141CE'], ['#F7D93F', '#EFAC00'], ['#43DACC', '#0EAF9F'], ['#FFB07F', '#FF8F49'], ['#FFA2B1', '#FF1C40']]
            return {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [{
                offset: 0, color: colorList[params.dataIndex][0]
              }, {
                offset: 1, color: colorList[params.dataIndex][1]
              }],
              global: false
            }
          }
        },
        label: {
          color: theme === 'dark' ? '#FFF' : '#333333',
          fontSize: '0.75rem',
          distanceToLabelLine: 0,
          formatter: (params) => {
            return params.name
          }
        },
        labelLine: {
          length: 0,
          length2: 10,
          lineStyle: {
            type: 'dashed'
          }
        },
        labelLayout: function (params) {
          const isLeft = params.labelRect.x < myChart.getWidth() / 2
          const points = params.labelLinePoints
          const verticalAlign = 'bottom'
          // Update the end point.
          points[2][0] = isLeft
            ? params.labelRect.x - 3
            : params.labelRect.x + params.labelRect.width - 3
          return {
            labelLinePoints: points,
            verticalAlign
          }
        },
        data: data || []
      }
    ]
  }
}

// 天气提醒
export function barOption (theme) {
  return {
    xAxis: {
      type: 'category',
      axisLabel: {
        color: theme === 'dark' ? '#FFF' : '#333333'
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: ['周', '月', '年']
    },
    tooltip: {
      trigger: 'axis'
    },
    yAxis: {
      type: 'value',
      show: false

    },
    grid: {
      top: '15%',
      bottom: '14%',
      left: '5%'
    },
    series: [
      {
        data: [0, 0, 0],
        type: 'bar',
        showBackground: true,
        barWidth: 24,
        backgroundStyle: {
          color: theme === 'dark' ? 'rgba(227, 233, 239, 0.2)' : '#E3E9EF',
          borderRadius: [12, 12, 0, 0]
        },
        label: {
          show: true,
          position: 'top',
          formatter (params) {
            return params.value + '条'
          },
          color: theme === 'dark' ? '#FFF' : '#333333'
        },
        itemStyle: {
          borderRadius: [12, 12, 0, 0],
          color: function (params) {
            const colorOption = {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [],
              global: false // 缺省为 false
            }
            if (params.name === '周') {
              colorOption.colorStops = [{
                offset: 0, color: '#59ACFB' // 0% 处的颜色
              }, {
                offset: 1, color: '#2D74F5' // 100% 处的颜色
              }]
            } else if (params.name === '月') {
              colorOption.colorStops = [{
                offset: 0, color: '#33DCD3' // 0% 处的颜色
              }, {
                offset: 1, color: '#17B6A7' // 100% 处的颜色
              }]
            } else if (params.name === '年') {
              colorOption.colorStops = [{
                offset: 0, color: '#FFC570' // 0% 处的颜色
              }, {
                offset: 1, color: '#FFA32C' // 100% 处的颜色
              }]
            } else {
              colorOption.colorStops = [{
                offset: 0, color: '#FF789A' // 0% 处的颜色
              }, {
                offset: 1, color: '#FF4361' // 100% 处的颜色
              }]
            }
            return colorOption
          }
        }
      }
    ]
  }
}

// 天气专报
export function barOption1 (theme) {
  return {
    xAxis: {
      type: 'value',
      show: false
    },
    yAxis: {
      type: 'category',
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        inside: true,
        margin: 0,
        align: 'left',
        color: theme === 'dark' ? '#FFF' : '#333333',
        verticalAlign: 'bottom',
        padding: [0, 0, 8, 0]
      },
      data: ['周', '月', '年']
    },
    grid: {
      top: '15%',
      bottom: '11%',
      left: '10%'
    },
    series: [
      {
        data: [120, 200, 150, 80],
        type: 'bar',
        showBackground: true,
        barWidth: 10,
        backgroundStyle: {
          color: theme === 'dark' ? 'rgba(227, 233, 239, 0.2)' : '#E3E9EF',
          borderRadius: [0, 5, 5, 0]
        },
        label: {
          show: true,
          position: 'right',
          color: theme === 'dark' ? '#FFF' : '#333333',
          formatter: function (params) {
            return params.value + '条'
          }
        },
        itemStyle: {
          borderRadius: [0, 5, 5, 0],
          color: function (params) {
            const colorOption = {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [],
              global: false // 缺省为 false
            }
            if (params.name === '周') {
              colorOption.colorStops = [{
                offset: 0, color: '#59ACFB' // 0% 处的颜色
              }, {
                offset: 1, color: '#2D74F5' // 100% 处的颜色
              }]
            } else if (params.name === '月') {
              colorOption.colorStops = [{
                offset: 0, color: '#33DCD3' // 0% 处的颜色
              }, {
                offset: 1, color: '#17B6A7' // 100% 处的颜色
              }]
            } else if (params.name === '年') {
              colorOption.colorStops = [{
                offset: 0, color: '#FFC570' // 0% 处的颜色
              }, {
                offset: 1, color: '#FFA32C' // 100% 处的颜色
              }]
            } else {
              colorOption.colorStops = [{
                offset: 0, color: '#FF789A' // 0% 处的颜色
              }, {
                offset: 1, color: '#FF4361' // 100% 处的颜色
              }]
            }
            return colorOption
          }
        }
      }
    ]
  }
}
